module.exports = __webpack_public_path__ + "public/img/1234.8b118181.gif";